angular.module('qkr').directive('showDepartmentName', () => ({
        restrict: 'E',

        replace: true,

        link(scope, elem, attrs) {
            // If department name starts with "@" then show the part after the "@"
            let s = attrs.name;
            if (s.indexOf('@') == 0) {
               s = s.slice(1, s.length);
            }
            elem.text(s);
        }
    }));



// WEBPACK FOOTER //
// ./src/directives/showDepartmentName.js